module.exports = __webpack_public_path__ + "static/9-094444e6582de155b2ad8483b65403db.png";